import React from "react"
import Dropdown from "../../../../Dropdown/Dropdown"
import { options } from "./options"
import { setEventType } from "../../useReducer/actionCreators"
import useOption from "./useOption"

const EventTypeDropdown = ({ externalDispatch, selectedType }) => {
  const [option, setOption] = useOption(selectedType)
  return (
    <Dropdown
      label="Event Type"
      id="event_type_dropdown"
      options={options}
      value={option}
      onChange={(option) => {
        setOption(option)
        externalDispatch(setEventType(option.id))
      }}
    />
  )
}
export default EventTypeDropdown
